import React, { useState } from 'react';
import { authAPI } from '../api';
import { t } from '../i18n';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    try {
      const res = await authAPI.passwordReset(email);
      setMessage(res.data?.detail || t('passwordResetLinkSent'));
      setEmail('');
    } catch (err) {
      setError(t('passwordResetRequestFailed'));
    }
  };

  return (
    <div className="container">
      <div className="card" style={{ maxWidth: '500px', margin: '50px auto' }}>
        <h2>{t('forgotPassword')}</h2>
        {message && <div style={{ color: 'green', marginBottom: '10px' }}>{message}</div>}
        {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{t('email')}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary">{t('sendResetLink')}</button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;